<script>
    import { updateSmartFilter, deleteSmartFilter } from '@/api/smartFilter.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_SMART_FILTER_EDIT},
        },
        methods: {
            async save() {
                const data = this.$store.getters.SMART_FILTER_DATA_EDIT;
                const response = await updateSmartFilter(data);
                if (response === true) {
                    this.$store.commit('IMAGE_SMART_FILTER_UPDATE', {
                        id: data.id,
                        payload: data,
                    });
                    await this.close();
                }
            },
            async deleteObj() {
                const data = this.$store.getters.SMART_FILTER_DATA_EDIT;
                const respone = await deleteSmartFilter(data.id);
                if (respone === true) {
                    this.$store.commit('IMAGE_SMART_FILTER_SPLICE', data.id);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_SMART_FILTER_EDIT', false);
            }
        }
    }
</script>

<template>
    <button
        :disabled="isSave === false"
        @click="save"
        class="button_blue_100"
    >Save</button>
    <button
        @click="deleteObj"
        class="button_blue_100 button_red ml_10"
    >Delete</button>
    <button
        @click="close"
        class="button_blue_100 close_button mr_10"
    >Close</button>
</template>